import formatDate from 'date-fns/format'
import startOfWeek from 'date-fns/start_of_week'
import getYear from 'date-fns/get_year'

export default function formatTimePeriodDate(timePeriod, date) {
  switch (timePeriod) {
    case 'day':
      return formatDate(date, 'D MMM YY')
    case 'week':
      return `w/c ${formatDate(startOfWeek(date, {weekStartsOn: 1}), 'D MMM YY')}`
    case 'month':
      return formatDate(date, 'MMMM YYYY')
    case 'year':
      return getYear(date)
    default:
      return formatDate(date, 'D MMM YY')
  }
}



// WEBPACK FOOTER //
// ./client/utils/formatTimePeriodDate.js